import styled from 'styled-components';
import { transparentThemeColour } from '../../../styles/ThemeColours';
import { ZIndex } from '../../../styles/constants';

export const Overlay = styled.div.attrs({ 'data-testid': 'overlay' })`
  background-color: ${transparentThemeColour('black', 0.6)};
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: ${ZIndex.OVERLAY};

  &.exit {
    opacity: 1;
  }

  &.exit-active {
    opacity: 0.01;
    transition: opacity 0.3s;
  }

  &.enter {
    opacity: 0.01;
  }

  &.enter-active {
    opacity: 1;
    transition: opacity 0.3s;
  }
`;
